// extracted by mini-css-extract-plugin
export default {"workshopRow":"UpcomingWorkshopCard_workshopRow__UaWNl","workshopName":"UpcomingWorkshopCard_workshopName__yoGN9","workshopDate":"UpcomingWorkshopCard_workshopDate__LYem0"};